import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import Pending from '@/components/login/pending'
import Register from '@/components/login/register'
import Homepage from '@/components/website/homepage'
import Waffir from '@/components/website/waffir'
import Terms from '@/components/website/terms'
import Dashboard from '@/components/account/dashboard'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Homepage,
    },
    {
      path: '/homepage',
      component: Homepage,
    },
    {
      path: '/waffir',
      component: Waffir,
    },
    {
      path: '/dashboard',
      component: Dashboard,
    },
    {
      path: '/login',
      component: Login,
      props: (route) => ({ redirect: route.query.redirect })
    },
    {
      path: '/pending',
      component: Pending
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/terms',
      component: Terms
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js